module.exports = __webpack_public_path__ + "img/MBT_W.8db94bd8.png";